import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "headset";
const pathData = "M256.5 1q48 0 90 18t73 49 49 73 18 90v128q0 31-12 59t-33 49-49 33-60 12h-76q-26 0-26-26v-25q0-26 26-26 25 0 25 26h51q20 0 36.5-7.5t30.5-18.5h-41q-11 0-18.5-7t-7.5-18V256q0-11 7.5-18t18.5-7h77q0-38-14-70.5T383 104t-57-38-69.5-14-70 14-57 38-38 56.5-14 70.5h77q25 0 25 25v154q0 25-25 25h-52q-32 0-54-22t-22-54V231q0-48 18-90t49-73 73-49 90-18zm-179 281v77q0 25 25 25h26V282h-51zm307 102h25q11 0 18.5-7t7.5-18v-77h-51v102z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/headset";
export { pathData, ltr, accData };